import React from 'react'
import useStyles from './Styles'
import { IProps } from './Interface'
import { Grid, Typography, useMediaQuery } from '@material-ui/core'
import { Section, Bean } from 'components'
import { theme } from 'config/constants/theme/theme'

const BackgroundBean: React.FC<IProps> = ({ beans, name, currentLocation, hometownLocation }) => {
  const classes = useStyles({})

  const mdSize = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Section
      size={{ height: mdSize ? 240 : 200 }}
      borderRadius={!mdSize ? { bottomLeft: 0, bottomRight: 0 } : {}}
      background={'#413292'}
      padding={23}
      direction={'column'}
    >
      <Grid item>
        <Typography id="snapshot-user-name-description-label" variant={'h3'} className={classes.h3}>
          Hi, I'm{' '}
          <span id="snapshot-user-name-label" data-testid="name">
            {name}
          </span>
          !
        </Typography>
        <Typography variant={'body1'} className={classes.body1}>
          {hometownLocation?.city ? (
            <span id="snapshot-hometown-city-description-label">
              I'm originally from{' '}
              <span id="snapshot-hometown-city-label" data-testid="hometown-city">
                {hometownLocation?.city}, {hometownLocation?.state}
              </span>
              {currentLocation?.city ? (
                <span id="snapshot-hometown-city-state-label" data-testid="hometown-state">
                  {' '}
                  now living in {currentLocation?.city}, {currentLocation?.state}.
                </span>
              ) : (
                '.'
              )}
            </span>
          ) : (
            currentLocation?.city && (
              <span id="snapshot-currently-living-label">
                I'm currently living in {currentLocation?.city}, {currentLocation?.state}.
              </span>
            )
          )}
        </Typography>
      </Grid>
      <Grid item>
        <div className={classes.beanContent}>
          <ul>
            {beans?.map((bean, i) => (
              <Bean key={`bean-${i}`} index={i} name={bean} animated fill rgbColor={'55, 42, 123'} opacity={1} />
            ))}
          </ul>
        </div>
      </Grid>
    </Section>
  )
}

BackgroundBean.defaultProps = {
  beans: [
    'undefined',
    'undefined',
    'undefined',
    'undefined',
    'undefined',
    'undefined',
    'undefined',
    'undefined',
    'undefined'
  ],
  name: 'Undefined',
  currentLocation: {
    id: '',
    city: 'unknown',
    state: 'unknown',
    country: 'unknown',
    code: 'un'
  },
  hometownLocation: {
    id: '',
    city: 'unknown',
    state: 'unknown',
    country: 'unknown',
    code: 'un'
  }
}

export default BackgroundBean
